<template>
  <base-modal>
    <z-table
      :fields="fields"
      :items="items"
      :show_pagination_description="false"
      :show_header="false"
      :show_per_page="false"
    >
      <template slot="status" slot-scope="{ item }">
        <state-badge :value="item.status" />
      </template>
    </z-table>
    <template #footer-cancel="{ close }">
      <i-button size="large" @click="close()">
        {{ $t('shared.component.button.close') }}
      </i-button>
    </template>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import { NewMessageService } from '@mailer/services/MessageService';
  import StateBadge from '@mailer/components/messages/messages-badge-state';

  export default {
    components: {
      BaseModal,
      StateBadge
    },

    props: {
      id: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        items: []
      };
    },

    computed: {
      fields: function () {
        return [
          {
            key: 'part_number',
            label: this.$t('mailer.mailing.modal.part_number')
          },
          {
            key: 'status',
            label: this.$t('mailer.mailing.modal.status')
          },
          {
            key: 'client_cost',
            label: this.$t('mailer.mailing.modal.client_cost'),
            formatter: (val) => this.$numeral.currency(val)
          }
        ];
      }
    },

    created() {
      NewMessageService.getParts(this.id).then((response) => {
        this.items = response;
      });
    }
  };
</script>
